const VIEWS = {
	list: 'All',
	'by-product': 'Split by Product',
};

const ViewControls = ({ view, setView }) => {
	const onSetView = (view) => {
		if (Object.keys(VIEWS).indexOf(view) === -1) return;
		setView(view);
	};
	return (
		<div className="view-controls">
			{Object.keys(VIEWS).map((key) => (
				<button
					key={key}
					className={`view-controls__button ${view === key ? 'is-active' : ''}`}
					onClick={() => onSetView(key)}
				>
					<img
						src={`./assets/icon--view--${key}.svg`}
						height="16"
						width="16"
						title={VIEWS[key]}
						alt={VIEWS[key]}
					/>
				</button>
			))}
		</div>
	);
};

export default ViewControls;
